<template>
    <div class="backpage" @click="goBack">
        <!-- <el-icon>
            <Back />
        </el-icon> -->
        ← 返回上一级
    </div>
    <div class="installt">
        <div class="intext"> {{ goodylist.name }} </div>

        <div class="addpoper" @click="openDialog">

            <div style="height: 24px;">添加礼包商品</div>

        </div>
    </div>
    <div class="goodymsg">
        <div class="neirong">
            <div class="neitop">
                <div class="neitop1">
                    礼包内容
                </div>
        
            </div>

            <div class="listss">
                <div class="libaps" v-for="(item, index) in goodylist.goodlist">
                    <div class="libaomm">
                        <div class="mmimg">
                            <img :src="images(item.pic)" alt="">
                        </div>
                        <div class="libaomms">
                            <div class="imgname" :title="item.name">{{ item.name }}</div>
                            <div class="imngnub">数量：

                                <!-- {{  }} -->
                                <el-input-number size="small" v-model="item.lpNums" :min="1" :max="9999"
                                    @blur="blurlibao(item, item.lpNums)" controls-position="right" />
                            </div>
                        </div>
                    </div>
                    <div style="font-size: 14px;color: #0091FF;cursor: pointer;" @click="removest(item, index)">
                        移除
                    </div>

                </div>

            </div>



        </div>
        <div class="goods">

            <div class="goodst">

                <div class="goodscoos">
                    <div class="weuuxan " :class="productType === 1 ? 'xuanzhong' : ''" @click="chagegood(1)">
                        店铺商品
                    </div>
                    <div class="weuuxan" :class="productType === 2 ? 'xuanzhong' : ''" @click="chagegood(2)">添加的商品</div>

                </div>
                <div class="goodseach">
                    <div style="width: 24px;height: 24px;">
                        <img style="width: 100%;height: 100%;" src="../../assets/secree.png" alt="">
                    </div>
                    <div>
                        <input type="text" placeholder="关键字搜索" v-model="wordKey" @keyup.enter="search">
                    </div>

                </div>

            </div>
            <table v-if="productType === 1">
                <thead>
                    <tr>
                        <th style="padding-left: 47px;box-sizing: border-box;  width: 300px;">商品</th>
                        <th style="width: 200px;">价格</th>
                        <th style="">数量</th>
                        <th style="width: 220px;">操作</th>
                    </tr>
                </thead>
                <tbody v-infinite-scroll="load" :infinite-scroll-immediate="false">
                    <tr v-for="(item, index) in pageProductlist ">
                        <td style="padding-left: 26px;box-sizing: border-box;width: 300px;">
                            <div class="libaomm">
                                <div class="mmimg">
                                    <img :src="images(item.ppreviewpic)" alt="">
                                </div>
                                <div class="libaomms">
                                    <div class="imgname" :title="item.pname">{{ item.pname }}</div>
                                    <div class="imngnub"></div>
                                </div>
                            </div>
                        </td>
                        <td style="width: 200px;">¥ {{ item.pprice }} </td>
                        <td class="ymoney" style="">
                            <el-input-number size="small" v-model="item.num" :min="1" :max="99"
                                controls-position="right" />

                        </td>
                        <td style="color: #0091FF;font-size: 14px;width: 220px;cursor: pointer;"
                            @click="addlibao(item, 1)">添加到礼包</td>
                    </tr>
                </tbody>
            </table>
            <table v-if="productType === 2">
                <thead>
                    <tr>
                        <th style="padding-left: 47px;box-sizing: border-box;  width: 300px;">商品</th>
                        <th style="width: 200px;">价格</th>
                        <th style="">数量</th>
                        <th style="  width: 220px;">操作</th>
                    </tr>
                </thead>
                <tbody v-infinite-scroll="load" :infinite-scroll-immediate="false">
                    <tr v-for="(item, index) in pageProductlist ">
                        <td style="padding-left: 26px;box-sizing: border-box;width: 300px;">
                            <div class="libaomm">
                                <div class="mmimg">
                                    <img :src="images(item.pic)" alt="">
                                </div>
                                <div class="libaomms">
                                    <div class="imgname" :title="item.name">{{ item.name }}</div>
                                    <div class="imngnub"></div>
                                </div>
                            </div>
                        </td>
                        <td style="width: 200px;">¥ {{ item.price }} </td>
                        <td class="ymoney" style="">
                            <el-input-number size="small" v-model="item.num" :min="1" :max="99"
                                controls-position="right" />
                        </td>
                        <td style="color: #0091FF;font-size: 14px;width: 220px;cursor: pointer;"
                            @click="addlibao(item, 2)">添加到礼包</td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
    <Mask ref="maskRef" :close-on-click-modal="false">
        <div class="addmy">
            <div style="padding: 27px 20px 0 36px;">
                <div class="dialogt">
                    <div>
                        添加商品
                    </div>
                    <div @click="closeDialog">
                        <el-icon>
                            <Close />
                        </el-icon>
                    </div>
                </div>
                <div class="libaoname">
                    <div>商品名称</div>
                    <div class="liname">
                        <input type="text" placeholder="请输入商品名称" v-model="goodname">
                    </div>

                </div>
                <div class="libaoname">
                    <div>商品价格（¥）</div>
                    <div class="liname">
                        <input type="text" placeholder="请输入商品价格" v-model="goodplay">
                    </div>

                </div>
                <div class="libaoname">
                    <div>库存</div>
                    <div class="liname">
                        <input type="text" placeholder="请输入商品库存" v-model="goodku">
                    </div>

                </div>
                <div class="libaoname">
                    <div>商品图片</div>
                    <div class="setupimg">
                        <div class="seimg">
                            <input type="file" id="avatar" name="avatar" accept="image/png, image/jpeg" ref="inputRef"
                                @change="tirggerFile($event)" />
                        </div>
                        <div class="jia">
                            <el-icon :size="30" color="#409EFC">
                                <Plus />
                            </el-icon>
                        </div>
                        <div class="images" @click="openImg" v-if="imgUrl != ''">
                            <img style="width:100%;height: 100%;" :src="imgUrl" />
                        </div>
                    </div>

                </div>
            </div>

            <div class="islibao">
                <div class="quxiao" @click="closeDialog"> 取消 </div>
                <div class="quxiao queren" @click="productFileUpload"> 保存 </div>

            </div>
        </div>
    </Mask>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import images from '@/utils/images';
import Mask from '@/components/mask/mask.vue';
import { ElMessage, ElMessageBox } from 'element-plus'
import storeapi from '@/api/store';
let goodylist = ref({})
let wordKey = ref('')
onMounted(() => {
    let goody = JSON.parse(sessionStorage.getItem('goody'))
    console.log('goody', goody)
    goodylist.value = goody
    pageProductvipGift()
})
let imgUrl = ref('')
let goodname = ref('')
let goodplay = ref('')
let goodku = ref('')
let file
let file2
const tirggerFile = (event) => {
    file = event.target.files[0];
    file2 = event.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file); // 以DataURL格式读取文件内容
    reader.onload = function (e) {
        imgUrl.value = reader.result; // 设置图片路径为DataURL
        console.log(imgUrl.value);
        // productFileUpload(file, file2);
    };
};

const productFileUpload = async () => {
    const formData = new FormData();
    formData.append('productName', goodname.value);
    formData.append('productPrice', goodplay.value);
    formData.append('storeId', goodylist.value.storeId);
    formData.append('productStockCount', goodku.value);

    // 将 ArrayBuffer 转换回 Blob
    const blob = new Blob([file2], { type: file.type });
    formData.append('filedata', blob, file.name); // 使用文件名附加文件

    const res = await storeapi.addGiftProduct(formData);
    console.log('productFileUpload', res);
    if (res.success) {
        ElMessage({
            message: '礼包商品添加成功.',
            type: 'success',
            duration: '1500',
            onClose: () => {
                // let pic = imgUrl.value
                // let data = {
                //     name:goodname.value,
                //     pic,
                //     price:goodplay.value,

                // }
                // goodylist.value.lpId.push(index, 1)
                goodname.value = ''
                goodplay.value = ''
                goodku.value = ''
                file = ''
                file2 = ''
                pageProductvipGift()
                closeDialog()
            }
        })
    } else {
        ElMessage.error(res.message)
    }
}
const openImg = () => {
    document.getElementById('avatar').click();
}
const removest = (item, index) => {
    ElMessageBox.confirm(
        '是否删除礼包中的商品?',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            alterProductCount(item, index)

        })
        .catch(() => {

        })
}
const blurlibao = async (item, num) => {

    console.log('blurlibao', item, num)

    let data = {
        giftId: goodylist.value.id,
        productCount: num,
        productId: item.lpId,
        productType: item.productType

    }
    const res = await storeapi.alterProductCount(data)

    if (res.success) {

    } else {
        ElMessage.error(res.message)
    }

}
const alterProductCount = async (item, index) => {
    let data = {
        giftId: goodylist.value.id,
        productCount: 0,
        productId: item.lpId,
        productType: item.productType

    }
    const res = await storeapi.alterProductCount(data)

    if (res.success) {
        ElMessage({
            message: '礼包商品删除成功.',
            type: 'success',
            duration: '1500',
            onClose: () => {
                // goodylist.value.lpProductList.splice(index, 1)
                // goodylist.value.lpNums.splice(index, 1)
                // goodylist.value.lpId.splice(index, 1)
                goodylist.value.goodlist.splice(index, 1)
            }
        })
    } else {
        ElMessage.error(res.message)
    }

}
const addlibao = (item, val) => {


    ElMessageBox.confirm(
        '是否添加商品?',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            addshangp(item, val);
        })
        .catch(() => {

        })

}




const addshangp = async (item, val) => {
    let data
    if (val === 1) {
        data = {
            giftId: goodylist.value.id,
            productCount: item.num,
            productId: item.pid,
            productType: val

        }
    } else {
        data = {
            giftId: goodylist.value.id,
            productCount: item.num,
            productId: item.lpId,
            productType: val
        }
    }

    const res = await storeapi.alterProductCount(data)

    if (res.success) {
        ElMessage({
            message: '礼包商品添加成功.',
            type: 'success',
            duration: '1500',
            onClose: () => {
                let data
                if (val === 1) {

                    data = {
                        lpId: item.pid,
                        lpNums: item.num,
                        name: item.pname,
                        pic: item.ppreviewpic,
                        price: item.pprice,
                        storeId: item.pcomid,
                        productType: val
                    }
                } else {
                    data = {
                        lpId: item.lpId,
                        lpNums: item.num,

                        name: item.name,
                        pic: item.pic,
                        price: item.price,
                        storeId: item.storeId,
                        productType: val

                    }
                }
                // goodylist.value.lpProductList.push(data)
                // goodylist.value.lpNums.push(value)
                goodylist.value.goodlist.push(data)
                console.log('goodylist.value', goodylist.value, data)


            }
        })
    } else {
        ElMessage.error(res.message)
    }
}

let pageProductlist = ref([])
let current = 1
let productType = ref(1)
const pageProductvipGift = async () => {
    let data = {
        "keyword": wordKey.value,
        "keywordType": 1,
        "page": {
            "current": current,
            "pageSize": 6
        }
    }
    let data2 = {
        productType: productType.value,
        storeId: goodylist.value.storeId
    }
    const res = await storeapi.pageProductvipGift(data, data2)
    console.log(res);
    if (res.success) {
        for (let a = 0; a < res.data.records.length; a++) {
            res.data.records[a].num = 1;

        }
        pageProductlist.value.push(...res.data.records)

    }
}
const load = () => {
    console.log(111)
    current++
    pageProductvipGift()
}

const search = () => {
    pageProductlist.value = [];
    current = 1;
    pageProductvipGift();

}
const chagegood = (val) => {
    if (val !== productType.value) {
        pageProductlist.value = [];
        current = 1;
        productType.value = val;
        wordKey.value = '';
        pageProductvipGift();
    }
}
//获取遮罩的实例
let maskRef = ref(null);
//打开弹窗
let openDialog = () => {
    maskRef.value.showMask();
};

//关闭弹窗
let closeDialog = () => {
    maskRef.value.closeMask();
};

const goBack = () => {
    window.history.back();
}
</script>

<style lang="scss" scoped>
.el-input-number--small {
    width: 90px;
}

table,
tbody {
    display: block;
    height: 580px;
    border: 0;
    border-spacing: 0;
    border-collapse: collapse;
    cursor: default;
}

tbody {
    overflow-y: scroll;
}

table thead,
tbody tr {
    display: table;
    width: 100%;
    table-layout: auto;
}

table thead {
    width: calc(100% - 1em)
}

.backpage {
    margin-top: -20px;
    font-size: 16px;
    color: #3F8CFF;
    cursor: pointer;
    height: 20px;
}

.installt {
    width: 100%;
    display: flex;
    height: 52px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpoper {
        width: 132px;
        height: 48px;
        background: rgba(63, 140, 255);
        box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
        border-radius: 8px;
        color: #FFFFFF;
        cursor: pointer;
        padding-left: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }

}

.goodymsg {
    margin-top: 22px;
    height: 704px;
    // background-color: #fff;
    border-radius: 8px;
    display: flex;
    width: 100%;

    .neirong {
        min-width: 364px;
        height: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        margin-right: 16px;

        .neitop {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 60px;
            border-bottom: 1px solid #EEEFF2;
            padding: 0 20px;
            box-sizing: border-box;

            .neitop1 {
                font-weight: 400;
                font-size: 16px;
                color: #4D525E;
            }

            .neitop2 {
                font-weight: 400;
                font-size: 14px;
                color: #0091FF;
                cursor: pointer;
            }
        }

        .listss {

            height: calc(100% - 60px);
            overflow: auto;

            .libaps {
                width: 100%;
                height: 96px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 24px;
                box-sizing: border-box;
                border-bottom: 1px solid #EEEFF2;

                .libaomm {
                    display: flex;
                    align-items: center;

                    .mmimg {
                        width: 56px;
                        height: 56px;
                        border-radius: 8px;
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .libaomms {
                        height: 46px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        margin-left: 10px;

                        .imgname {
                            width: 200px;
                            height: 30px;
                            font-size: 16px;
                            color: #111827;
                            text-overflow: ellipsis;
                            /*省略号 */
                            white-space: nowrap;
                            /*溢出时不换行 */
                            overflow: hidden;
                            /*溢出时隐藏 */
                        }

                        .imngnub {
                            font-size: 14px;
                            color: #718096;
                        }
                    }




                }
            }
        }


    }

    .goods {
        min-width: 800px;
        width: calc(100% - 354px);
        height: 100%;
        background: #FFFFFF;
        border-radius: 8px;

        .goodst {
            width: 100%;
            height: 71px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 22px;
            box-sizing: border-box;

            .goodscoos {
                display: flex;
                justify-content: space-between;
                height: 44px;

                .weuuxan {
                    white-space: nowrap;
                    margin-right: 39px;
                    font-weight: 400;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.88);
                    line-height: 44px;
                    cursor: pointer;
                }

                .xuanzhong {
                    font-weight: 500;
                    color: #1677FF;
                    border-bottom: 2px solid #1677FF;
                }
            }

            .goodseach {
                width: 412px;
                height: 48px;
                margin-right: 24px;
                background: #FAFAFA;
                box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
                border-radius: 8px;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding-left: 20px;

                input {
                    width: 300px;
                    border: none;
                    outline: none;
                    font-size: 16px;
                    background: #FAFAFA;

                }

                ::placeholder {
                    font-weight: 400;
                    font-size: 14px;
                    color: #7D8592;
                }
            }

        }

        table {
            width: 100%;
            border-collapse: collapse;

            thead {
                width: 100%;
                height: 48px;
                background: #F8F8F8;
                line-height: 48px;
                font-size: 14px;
                color: #4D585F;
                text-align: left;


            }

            tbody {

                tr {
                    height: 101px;
                    border-bottom: 1px solid #EEEFF2;

                    .libaomm {
                        display: flex;
                        align-items: center;
                        height: 101px;

                        .mmimg {
                            width: 56px;
                            height: 56px;
                            border-radius: 8px;
                            overflow: hidden;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .libaomms {
                            height: 46px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            margin-left: 10px;

                            .imgname {
                                margin-right: 5px;
                                width: 170px;
                                font-size: 16px;
                                color: #111827;
                                line-height: 18px;

                                overflow: hidden;
                                white-space: wrap;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                /* 显示两行 */
                                -webkit-box-orient: vertical;
                                // white-space: nowrap;
                            }

                            .imngnub {
                                font-size: 14px;
                                color: #718096;
                                line-height: 18px;

                            }
                        }
                    }

                    .ymoney {
                        white-space: nowrap;
                        font-size: 14px;
                        color: #718096;
                    }

                    td {
                        // line-height: 101px;
                        vertical-align: middle;
                    }
                }
            }
        }
    }
}

.addmy {
    width: 465px;
    // height: 443px;
    background: #FFFFFF;
    border-radius: 8px;
    border-radius: 8px;

    font-size: 16px;
    color: #111827;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;

    }


    .libaoname {
        margin-top: 27px;
        margin-left: 10px;


        .setupimg {
            margin-top: 10px;
            width: 80px;
            height: 80px;
            background: #F2F3F5;
            position: relative;

            .images {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                overflow: hidden;
                // video{
                //     width: 100%;
                //     height: 100%;
                // }
            }

            .jia {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            .seimg {

                width: 80px;
                height: 80px;

                input {
                    padding: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }
            }

            .tioajian {
                width: 80px;
                height: 23px;
                background: #8F8F8F;
                font-size: 11px;
                line-height: 23px;
                text-align: center;
                font-weight: 400;
                color: #FFFFFF;
            }
        }

        .liname {
            width: 391px;
            height: 56px;
            background: #FAFAFA;
            margin-top: 16px;

            input {
                height: 56px;

            }
        }
    }

    .islibao {
        width: 100%;
        height: 101px;
        border-top: 1px solid #EEEFF2;
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-top: 55px;

        .quxiao {
            width: 108px;
            height: 48px;
            border: 1px solid #979797;
            text-align: center;
            line-height: 48px;
            border-radius: 8px;
            cursor: pointer;

        }

        .queren {
            background: #79AFFF;
            color: #FFFFFF;
            border: 1px solid transparent;

        }
    }
}
</style>